import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  LegendBoxContentsName,
  LegendBoxList,
  LegendCssCircleIcoListItem,
  LegendCssSquareIconListItem,
  LegendListDivider
} from "../../legend/LegendBoxComponents";
import { memo } from "react";

function LegendSynop() {
  const {t} = useTranslation();
  return (
    <>
      <Box sx={{display:'flex', columnGap:10, minWidth: 112}}>
        <div>
          <LegendBoxContentsName>{t("Average Horizontal visibility")} (m)</LegendBoxContentsName>
          <Box sx={{display: "flex"}}>
            <LegendBoxList>
              <LegendCssSquareIconListItem background={'rgb(251, 0, 7)'} text={<>1000</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgb(255, 255, 10)'} text={<>3200</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgb(27, 120, 255)'} text={<></>}></LegendCssSquareIconListItem>
              <LegendCssCircleIcoListItem background={'rgb(255, 255, 255)'} text={"NILL"}></LegendCssCircleIcoListItem>
            </LegendBoxList>
          </Box>
        </div>
        <Wind/>
      </Box>
    </>
  );
}

function Wind() {
  const {t} = useTranslation();
  return (
    <div>
      <LegendBoxContentsName>{t("Wind speed")} (kt)</LegendBoxContentsName>
      <Box sx={{display:  "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(251, 0, 6)'} text={<>48</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(253, 135, 9)'} text={<>38</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 11)'} text={<>28</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(34, 255, 8)'} text={<>18</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 0, 255)'} text={<>8</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 0, 0)'} text={<>0</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
        </LegendBoxList>
      </Box>
    </div>
  )
}

export default memo(LegendSynop);